import React, { useReducer, useEffect, useRef, useState } from "react";
import { Container, Row, Form, Col, Button, Accordion } from "react-bootstrap";
import "../../variables.scss";
import "./order.scss";
import Header from "../../compnents/Header";
import Footer from "../../compnents/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTrash } from "@fortawesome/free-solid-icons";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { submitBulkOrderRequest } from "../../redux/reducer/BulkOrder";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const initialState = {
  formData: {
    user_full_name: "",
    user_email: "",
    user_phone: "",
    user_organisation: "",
    additional_information: "",
    address_line: "",
    pincode: "",
    city: "",
    products: [],
  },
  errors: {},
  matchingCollections: [],
  category: [],
  activeVariants: {},
  selectedCategory: { category_id: "", category_name: "" },
  select: "Lookin For",
  toggle: 0,
  products: [],
  check: false,
  summery: [],
  quantities: {},
  topOffset: "20px",
};

const formReducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_FORM":
      return {
        ...state,
        formData: { ...state.formData, ...action.payload },
        errors: {
          ...state.errors,
          [Object.keys(action.payload)[0]]: validateField(
            Object.keys(action.payload)[0],
            Object.values(action.payload)[0]
          ),
        },
      };
    case "UPDATE_QUANTITIES":
      return {
        ...state,
        quantities: { ...state.quantities, ...action.payload },
      };
    case "UPDATE_STATE":
      return { ...state, ...action.payload };
    case "SET_ERRORS":
      return { ...state, errors: { ...state.errors, ...action.payload } };
    case "CLEAR_FORM":
      return {
        ...state,
        formData: { ...initialState.formData, products: [] },
        errors: {},
        summery: [],
        selectedCategory: { category_id: "", category_name: "" },
        quantities: {},
        select: "Lookin For",
        toggle: 0,
        check: false,
        products: [],
      };
    default:
      return state;
  }
};

// Validation function
const validateField = (field, value) => {
  switch (field) {
    case "user_full_name":
      return value.trim() === "" ? "Name is required" : "";
    case "user_email":
      return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
        ? "Valid email is required"
        : "";
    case "user_phone":
      return !/^\d{10}$/.test(value)
        ? "Valid 10-digit phone number is required"
        : "";
    case "user_organisation":
      return value.trim() === "" ? "Organization is required" : "";
    case "address_line":
      return value.trim() === "" ? "Address is required" : "";
    case "pincode":
      return !/^\d{6}$/.test(value) ? "Valid 6-digit pincode is required" : "";
    case "city":
      return value.trim() === "" ? "City is required" : "";
    case "additional_information":
      return value.trim() === "" ? "Additional information is required" : "";
    default:
      return "";
  }
};

function BulkOrder() {
  const BulkOrderReducer = useSelector((state) => state.BulkOrderReducer);
  // console.log(BulkOrderReducer, "???BulkOrderReducer");
  const SHOPIFY_ENDPOINT = process.env.REACT_APP_SHOPIFY_ENDPOINT;
  const SHOPIFY_TOKEN = process.env.REACT_APP_SHOPIFY_TOKEN;
  const [state, dispatchReducer] = useReducer(formReducer, initialState);
  const [hide, setHide] = useState(false);
  const dispatch = useDispatch();
  const isAdmin = true;
  const [selectCollection, setSelectCollection] = useState({
    category_id: "",
    category_name: "",
  });
  const qtyRef = useRef();
  const sumRef = useRef();

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Check if running inside a WebView (Android or iOS)
    const isIOSWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
      userAgent
    ); // iOS WebView

    const isAndroidWebView =
      /\bwv\b/i.test(userAgent) || // Android WebView "wv" in userAgent
      /Version\/[\d.]+.*Chrome\/[\d.]+.*Mobile Safari\/[\d.]+/i.test(userAgent); // Older Android WebView

    const isWebView = isIOSWebView || isAndroidWebView;

    if (isWebView) {
      // console.log("Running inside a WebView (probably app)");
      setHide(true);
    } else {
      // console.log("Likely a browser");
      setHide(false); // explicitly show if in browser
    }
  }, []);

  const targetIds = [
    "gid://shopify/Collection/186279919748",
    "gid://shopify/Collection/177428627588",
    "gid://shopify/Collection/283344339109",
    "gid://shopify/Collection/177241063556",
    "gid://shopify/Collection/286419615909",
    "gid://shopify/Collection/289145159845",
    "gid://shopify/Collection/177426563204",
    "gid://shopify/Collection/294152339621",
    "gid://shopify/Collection/286419648677",
    "gid://shopify/Collection/294777389221",
    "gid://shopify/Collection/302963851429",
    "gid://shopify/Collection/199222591653",
  ];

  useEffect(() => {
    const query = `{
    collections(first: 250) {
      edges {
        node {
          id
          title
          products(first: 100) {
            edges {
              node {
                id
                title
                images(first: 1) { nodes { url } }
                variants(first: 10) {
                  edges {
                    node {
                      id
                      title
                      sku
                      priceV2 { amount currencyCode }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }`;

    const fetchCollections = async () => {
      try {
        const response = await fetch(SHOPIFY_ENDPOINT, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": SHOPIFY_TOKEN,
          },
          body: JSON.stringify({ query }),
        });

        const json = await response.json();
        const allCollections =
          json?.data?.collections?.edges?.map((edge) => edge.node) || [];

        const matching = allCollections.filter((col) =>
          targetIds.includes(col.id)
        );

        const allProducts = matching.flatMap((col) =>
          col.products.edges.map((edge) => edge.node)
        );

        const defaults = {};
        allProducts.forEach((p) => {
          const first = p.variants.edges[0]?.node;
          if (first) {
            defaults[p.id] = { ...first, sku: first.sku || "" };
          }
        });

        // Instead of calling changeSelect here...
        dispatchReducer({
          type: "UPDATE_STATE",
          payload: {
            matchingCollections: matching,
            category: matching.map((col) => col.title),
            activeVariants: defaults,
          },
        });
      } catch (err) {
        console.error("Error fetching collections:", err);
        toast.error("Failed to fetch products");
      }
    };

    fetchCollections();
  }, []);

  useEffect(() => {
    dispatchReducer({
      type: "UPDATE_STATE",
      payload: {
        topOffset:
          state.check && sumRef.current
            ? `-${sumRef.current.clientHeight + 150}px`
            : "20px",
      },
    });
  }, [state.summery, state.check]);

  useEffect(() => {
    dispatchReducer({
      type: "UPDATE_FORM",
      payload: { products: state.summery },
    });
  }, [state.summery]);

  const changeSelect = (title) => {
    // setSelectCollection(title)
    setSelectCollection(title);
    const selectedCollection = state.matchingCollections.find(
      (col) => col.title === title
    );
    const collectionProducts =
      selectedCollection?.products?.edges?.map((edge) => edge.node) || [];
    // console.log("selected pro::::", collectionProducts);
    dispatchReducer({
      type: "UPDATE_STATE",
      payload: {
        select: title,
        selectedCategory: {
          category_id: selectedCollection?.id || "",
          category_name: title,
        },
        toggle: false,
        check: true,
        products: collectionProducts,
      },
    });
  };

  const handleAccordionToggle = (eventKey) => {
    dispatchReducer({
      type: "UPDATE_STATE",
      payload: { toggle: state.toggle === eventKey ? null : eventKey },
    });
  };

  const handleQtyChange = (e, productId) => {
    let value = parseInt(e.target.value, 10);
    if (isNaN(value)) value = "";
    if (value > 1000) value = 1000;
    if (value < 1 && value !== "") value = 1;

    dispatchReducer({
      type: "UPDATE_QUANTITIES",
      payload: { [productId]: value },
    });
  };

  const handlePhoneInput = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 10);
    dispatchReducer({
      type: "UPDATE_FORM",
      payload: { user_phone: value },
    });
  };

  const isButtonDisabled = (productId) => {
    const value = state.quantities[productId];
    return value === "" || isNaN(value) || Number(value) <= 0;
  };

  const addSummery = (product) => {
    const qty = state.quantities[product.id];
    const selectedVariant = state.activeVariants[product.id];

    if (!qty || isNaN(qty) || Number(qty) <= 0) {
      toast.error("Please enter a valid quantity");
      return;
    }

    const productPayload = {
      product_id: selectedVariant?.sku || "",
      product_name: product.title,
      product_variant: selectedVariant?.title || "",
      category_id: state.selectedCategory.category_id || "dsadh231",
      category_name: state.selectedCategory.category_name || "sunscreen",
      quantity: Number(qty),
      price: selectedVariant?.priceV2?.amount || 0,
      product_image: product.images.nodes[0]?.url || "",
      // sku_id: selectedVariant?.sku || "",
    };

    // console.log("sku:::", productPayload);

    dispatchReducer({
      type: "UPDATE_STATE",
      payload: {
        summery: (() => {
          const idx = state.summery.findIndex(
            (item) =>
              item.product_id === productPayload.product_id &&
              item.product_variant === productPayload.product_variant
          );
          if (idx !== -1) {
            const updated = [...state.summery];
            updated[idx] = {
              ...updated[idx],
              quantity: updated[idx].quantity + productPayload.quantity,
            };
            return updated;
          }
          return [...state.summery, productPayload];
        })(),
        quantities: { ...state.quantities, [product.id]: "" },
      },
    });
    toast.success("Product added to summary");
  };

  const handleRemove = (productId, variantId) => {
    dispatchReducer({
      type: "UPDATE_STATE",
      payload: {
        summery: state.summery.filter(
          (item) =>
            !(
              item.product_id === productId &&
              item.product_variant === variantId
            )
        ),
      },
    });
    toast.info("Product removed from summary");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};
    Object.keys(state.formData).forEach((key) => {
      const error = validateField(key, state.formData[key]);
      if (error) newErrors[key] = error;
    });

    if (state.formData.products.length === 0) {
      newErrors.products = "Please select at least one product";
    }

    dispatchReducer({ type: "SET_ERRORS", payload: newErrors });

    if (Object.keys(newErrors).length > 0) {
      toast.error("Please fix the form errors");
      return;
    }

    dispatch(submitBulkOrderRequest(state.formData));
    dispatchReducer({ type: "CLEAR_FORM" });
    toast.success("Order Placed Successfully");
  };

  useEffect(() => {
    if (state.matchingCollections.length > 0) {
      const defaultCollection = state.matchingCollections.find(
        (col) => col.id === "gid://shopify/Collection/186279919748"
      );
      if (defaultCollection) {
        changeSelect(defaultCollection.title);
      }
    }
  }, [state.matchingCollections]);
  // console.log("hide:::", hide);

  return (
    <>
      {hide ? null : <Header hideUserTab={true} admin={isAdmin} />}

      <section className="banner" />
      <section className="form">
        <h3>Bulk Order Inquiry / Corporate Gifting Form</h3>
        <Form onSubmit={handleSubmit}>
          <Container>
            <Row>
              <Col md={9} className="m-auto">
                <Row className="gg1">
                  <Col md={{ span: 6, order: 1 }} xs={{ order: 2 }}>
                    <Row>
                      <Col md={12} className="mb-4">
                        <Form.Group controlId="formName" className="mb-2">
                          <Form.Control
                            type="text"
                            placeholder="Name*"
                            value={state.formData.user_full_name}
                            onChange={(e) =>
                              dispatchReducer({
                                type: "UPDATE_FORM",
                                payload: { user_full_name: e.target.value },
                              })
                            }
                            isInvalid={!!state.errors.user_full_name}
                          />
                          <Form.Control.Feedback type="invalid">
                            {state.errors.user_full_name}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={12} className="mb-4">
                        <Form.Group controlId="formEmail" className="mb-2">
                          <Form.Control
                            type="email"
                            placeholder="Email*"
                            value={state.formData.user_email}
                            onChange={(e) =>
                              dispatchReducer({
                                type: "UPDATE_FORM",
                                payload: { user_email: e.target.value },
                              })
                            }
                            isInvalid={!!state.errors.user_email}
                          />
                          <Form.Control.Feedback type="invalid">
                            {state.errors.user_email}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={12} className="mb-4">
                        <Form.Group controlId="formNumber" className="mb-2">
                          <Form.Control
                            type="text"
                            placeholder="Phone*"
                            value={state.formData.user_phone}
                            onChange={handlePhoneInput}
                            onInput={handlePhoneInput}
                            maxLength={10}
                            pattern="\d*"
                            isInvalid={!!state.errors.user_phone}
                          />
                          <Form.Control.Feedback type="invalid">
                            {state.errors.user_phone}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={12} className="mb-4">
                        <Form.Group controlId="formOrg" className="mb-2">
                          <Form.Control
                            type="text"
                            placeholder="Enter Organization*"
                            value={state.formData.user_organisation}
                            onChange={(e) =>
                              dispatchReducer({
                                type: "UPDATE_FORM",
                                payload: { user_organisation: e.target.value },
                              })
                            }
                            isInvalid={!!state.errors.user_organisation}
                          />
                          <Form.Control.Feedback type="invalid">
                            {state.errors.user_organisation}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={{ span: 6, order: 1 }} xs={{ order: 1 }} className="pb-3" >
                    <div className="selection-box">
                      <p>Select what you want to purchase</p>
                      <div className="header-wrap">
                        <Accordion
                          activeKey={state.toggle}
                          onSelect={handleAccordionToggle}
                        >
                          <Accordion.Item eventKey="0">
                            <Accordion.Header>{state.select}</Accordion.Header>
                            <Accordion.Body>
                              <ul>
                                {state.category.map((item, index) => (
                                  <li
                                    key={index}
                                    onClick={() => changeSelect(item)}
                                  >
                                    {item}
                                  </li>
                                ))}
                              </ul>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                        <p className="result">{`${state.products.length} Results`}</p>
                      </div>
                      <div
                        className="product-list"
                        style={{ height: state.check ? "50vh" : "0vh" }}
                      >
                        {state.products.map((product) => (
                          <div className="pro-card" key={product.id}>
                            <div className="img-wrap">
                              <img
                                src={product.images.nodes[0]?.url}
                                alt={product.title}
                              />
                            </div>
                            <div className="pro-dtls">
                              <p className="pro-title">{product.title}</p>
                              <div className="pro-variant">
                                {product.variants.edges.length > 2 ? (
                                  <>
                                    {state.activeVariants[product.id] && (
                                      <p className="selected-variant">
                                        {state.activeVariants[product.id].title}
                                      </p>
                                    )}
                                    <select
                                      value={
                                        state.activeVariants[product.id]?.id ||
                                        ""
                                      }
                                      onChange={(e) => {
                                        const selectedVariant =
                                          product.variants.edges.find(
                                            (v) => v.node.id === e.target.value
                                          )?.node;
                                        if (selectedVariant) {
                                          dispatchReducer({
                                            type: "UPDATE_STATE",
                                            payload: {
                                              activeVariants: {
                                                ...state.activeVariants,
                                                [product.id]: selectedVariant,
                                              },
                                            },
                                          });
                                        }
                                      }}
                                    >
                                      <option value="">Select Variant</option>
                                      {product.variants.edges.map(
                                        (variantEdge) => (
                                          <option
                                            key={variantEdge.node.id}
                                            value={variantEdge.node.id}
                                          >
                                            {variantEdge.node.title}
                                          </option>
                                        )
                                      )}
                                    </select>
                                  </>
                                ) : (
                                  product.variants.edges.map((variantEdge) => {
                                    const variant = variantEdge.node;
                                    const isActive =
                                      state.activeVariants[product.id]?.id ===
                                      variant.id;
                                    return (
                                      <div
                                        className={`each-var ${
                                          isActive ? "active" : ""
                                        }`}
                                        key={variant.id}
                                        onClick={() =>
                                          dispatchReducer({
                                            type: "UPDATE_STATE",
                                            payload: {
                                              activeVariants: {
                                                ...state.activeVariants,
                                                [product.id]: variant,
                                              },
                                            },
                                          })
                                        }
                                      >
                                        {variant.title}
                                      </div>
                                    );
                                  })
                                )}
                              </div>
                            </div>
                            <div className="pro-qty">
                              <input
                                type="text"
                                placeholder="Enter Qty."
                                value={state.quantities[product.id] || ""}
                                onChange={(e) => handleQtyChange(e, product.id)}
                                ref={qtyRef}
                                min={1}
                                max={1000}
                              />
                              <button
                                onClick={() => addSummery(product)}
                                disabled={isButtonDisabled(product.id)}
                              >
                                ADD
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="added-box mt-5" ref={sumRef}>
                      <h4>Added Summary</h4>
                      <div className="sum-box">
                        {state.summery.length > 0 ? (
                          <ul>
                            {state.summery.map((item, i) => (
                              <li key={i} className="add-item">
                                <div className="img-wrap">
                                  <img
                                    src={
                                      item.product_image ||
                                      "/fallback-image.jpg"
                                    }
                                    alt=""
                                  />
                                </div>
                                <div className="pro-dtls">
                                  {item.product_name}
                                  {item.product_variant &&
                                    ` (${item.product_variant})`}
                                  <br />
                                  <b>Qty: {item.quantity}</b>
                                </div>
                                <button
                                  onClick={() =>
                                    handleRemove(
                                      item.product_id,
                                      item.product_variant
                                    )
                                  }
                                  type="button"
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <p>You have not added any product yet...</p>
                        )}
                        {state.errors.products && (
                          <p className="text-danger">{state.errors.products}</p>
                        )}
                      </div>
                    </div>
                  </Col>
                  <Col md={{ span: 6, order: 1 }} xs={{ order: 3 }} className="gg" style={{ top: state.topOffset }}>
                    <Row>
                      <p className="mb-3">Add your address</p>
                      <Col md={12} className="mb-3">
                        <Form.Group controlId="formAddress" className="mb-3">
                          <Form.Control
                            type="text"
                            placeholder="House number, flat number*"
                            value={state.formData.address_line}
                            onChange={(e) =>
                              dispatchReducer({
                                type: "UPDATE_FORM",
                                payload: { address_line: e.target.value },
                              })
                            }
                            isInvalid={!!state.errors.address_line}
                          />
                          <Form.Control.Feedback type="invalid">
                            {state.errors.address_line}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} sm={6} xs={6}>
                        <Form.Group controlId="formPincode" className="mb-3">
                          <Form.Control
                            type="text"
                            placeholder="Pincode*"
                            value={state.formData.pincode}
                            onChange={(e) =>
                              dispatchReducer({
                                type: "UPDATE_FORM",
                                payload: { pincode: e.target.value },
                              })
                            }
                            isInvalid={!!state.errors.pincode}
                          />
                          <Form.Control.Feedback type="invalid">
                            {state.errors.pincode}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} sm={6} xs={6}>
                        <Form.Group controlId="formCity" className="mb-3">
                          <Form.Control
                            type="text"
                            placeholder="City*"
                            value={state.formData.city}
                            onChange={(e) =>
                              dispatchReducer({
                                type: "UPDATE_FORM",
                                payload: { city: e.target.value },
                              })
                            }
                            isInvalid={!!state.errors.city}
                          />
                          <Form.Control.Feedback type="invalid">
                            {state.errors.city}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={12} className="mt-4">
                        <label className="mb-4">
                          Additional information (Anything else that you would
                          require eg cards, gift wrap, business card etc)
                        </label>
                        <Form.Control
                          as="textarea"
                          value={state.formData.additional_information}
                          onChange={(e) =>
                            dispatchReducer({
                              type: "UPDATE_FORM",
                              payload: {
                                additional_information: e.target.value,
                              },
                            })
                          }
                          isInvalid={!!state.errors.additional_information}
                        />
                        <Form.Control.Feedback type="invalid">
                          {state.errors.additional_information}
                        </Form.Control.Feedback>
                      </Col>
                      <Col md={12}>
                        <Button className="submit" type="submit">
                          Enquire Now
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </Form>
      </section>
      <Footer />
    </>
  );
}

export default BulkOrder;
